import { AttachmentPaginationActions } from './AttachmentPagination';
import { AttachmentPagination } from './AttachmentPaginationAction';

export const customPaginationAttachment = <T extends object>({
  attachment,
  isLoading,
}: {
  attachment: boolean | undefined;
  isLoading: boolean | undefined;
}) => {
  return attachment
    ? {
        Pagination: AttachmentPagination<T>(),
        PaginationActions: AttachmentPaginationActions<T>({
          loading: isLoading,
        }),
      }
    : undefined;
};
